import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticleGrid() {
  const displayArticles = articles.filter((a) => a.slug !== 'kakobuy-spreadsheet-poradnik').slice(0, 9);

  return (
    <section className="relative w-full py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-300/40 font-label text-xs font-medium text-foreground-600 mb-4">
            Poradniki i Artykuły
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 leading-tight mb-4">
            Wszystko o <span className="text-accent-600">Kakobuy Spreadsheet</span>
          </h2>
          <p className="font-body text-base text-foreground-600 max-w-2xl mx-auto">
            Praktyczne poradniki, tutoriale i przewodniki które pomogą Ci w pełni wykorzystać potencjał Kakobuy Spreadsheet
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {displayArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/artykul/${article.slug}`}
              className="group rounded-2xl overflow-hidden bg-background-100 hover:bg-accent-50/20 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
                <div className="absolute bottom-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-full bg-background-50/80 backdrop-blur-sm font-label text-xs font-medium text-foreground-800">
                    Poradnik
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 group-hover:text-accent-600 transition-colors line-clamp-2 mb-2">
                  {article.title}
                </h3>
                <p className="font-body text-sm text-foreground-600 line-clamp-2 mb-3">
                  {article.summary}
                </p>
                <div className="flex items-center justify-between">
                  <span className="font-body text-xs text-foreground-500">{article.date}</span>
                  <span className="inline-flex items-center gap-1 font-label text-xs font-medium text-accent-600">
                    Czytaj więcej
                    <i className="ri-arrow-right-line text-xs"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/artykul/kakobuy-spreadsheet-poradnik"
            className="inline-flex items-center gap-2 px-6 py-3 bg-foreground-950 text-background-50 font-label text-sm font-semibold rounded-full hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            Zobacz pełny poradnik
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}